var _defs, _path, _path2, _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpackNew316({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:none;stroke:#fff;stroke-linejoin:round;stroke-width:0.41px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1.66,5.63V2.79H.79V2.41H2.88v.38H2V5.63Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M3.22,5.63V2.41h.92a1.69,1.69,0,0,1,.51.06.84.84,0,0,1,.4.28,1.49,1.49,0,0,1,.26.52,2.26,2.26,0,0,1,.1.73,2.5,2.5,0,0,1-.16.93,1.14,1.14,0,0,1-.41.54,1.2,1.2,0,0,1-.66.16Zm.35-.38h.57a1,1,0,0,0,.51-.11.64.64,0,0,0,.27-.36A2.06,2.06,0,0,0,5.05,4a2,2,0,0,0-.13-.77.77.77,0,0,0-.35-.38,1.18,1.18,0,0,0-.44-.06H3.57Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 10.53,
    cy: 10.5,
    r: 4.32
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 10.53,
    cy: 10.5,
    r: 2.59
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpackNew316);
export default __webpack_public_path__ + "static/media/Symbolpack_New_316.687c2d6ea9db57393969987b227a360e.svg";
export { ForwardRef as ReactComponent };